// Página de éxito de compra en Mercado Pago
// Muestra confirmación de pago exitoso y redirige al radar

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';

/**
 * Componente EcommerceSuccess
 * Muestra mensaje de éxito después de completar el pago en Mercado Pago
 */
const EcommerceSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirigir al radar después de 3 segundos
    const timer = setTimeout(() => {
      navigate('/radar');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900 px-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-green-100 dark:bg-green-900 rounded-full p-4">
            <FaCheckCircle className="w-12 h-12 text-green-600 dark:text-green-400" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          ¡Pago Exitoso!
        </h1>
        
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Tu compra ha sido procesada correctamente. Serás redirigido al radar en unos segundos.
        </p>
        
        <button
          onClick={() => navigate('/radar')}
          className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg font-medium transition-colors"
        >
          Ir al Radar
        </button>
      </div>
    </div>
  );
};

export default EcommerceSuccess;
